module.exports = __webpack_public_path__ + "img/shield.51c832f9.jpg";